<template>
    <div style="background: #FFFFFF;">
        <div class="banner">
            <img
                :src="require('../../../../assets/img/common/banner_common.png')" />
        </div>
        <br></br>
        <honor-img :list="certificateList"></honor-img>
    </div>
</template>

<script>
import honorImg from './honorImg'
import $ from 'jquery'
export default {
    components: {
        honorImg,
    },
    data() {
        return {
            certificateList: [
                {
                    url: require('../../../../assets/img/certificate/c1.jpg'),
                    title: '建筑企业资质',
                },
                 {
                    url: require('../../../../assets/img/certificate/c2.jpg'),
                    title: '陕西省瞪羚企业',
                },
                 {
                    url: require('../../../../assets/img/certificate/c3.jpg'),
                    title: '安全生产许可证',
                },
                 {
                    url: require('../../../../assets/img/certificate/c4.jpg'),
                    title: '高新技术企业证书',
                },
                 {
                    url: require('../../../../assets/img/certificate/c5.jpg'),
                    title: '环境管理体系认证证书',
                },
                 {
                    url: require('../../../../assets/img/certificate/c6.jpg'),
                    title: '职业健康安全管理体系认证证书',
                },
                 {
                    url: require('../../../../assets/img/certificate/c7.jpg'),
                    title: '质量管理体系认证证书',
                },
                {
                    url: require('../../../../assets/img/certificate/i1.jpg'),
                    title: '空调自控系统等7个软件著作权',
                },
                {
                    url: require('../../../../assets/img/certificate/i2.jpg'),
                    title: '环境监测与设备控制等5个软件著作权',
                },
                {
                    url: require('../../../../assets/img/certificate/i3.jpg'),
                    title: '能源管理等4个软件著作权',
                },
                {
                    url: require('../../../../assets/img/certificate/i4.jpg'),
                    title: '智能可视化数字工厂管理品台等4个软件等著作权',
                },
            ]
        }
    },
    methods: {
        
    },
    mounted() {
        
    },
}
</script>


<style lang="less" scoped>
@import '@/assets/css/certificate.less';
</style>